<template>
  <details class="additional-actions mb-4">
    <summary @click="this.toggleOpen()">
      <IconProvider name="ChevronDown" v-if="!isOpen" />
      <IconProvider name="ChevronUp" v-else />
      <span class="additional-actions-title ml-2">Additional Actions</span>
    </summary>
    
    <div class="actions-grid">
      <div
        v-for="action in actions"
        :key="action.action"
        class="action-item"
        @click="performAction(action.action)"
        :class="{ 'action-item-disabled': action.disabled }"
      >
        <IconProvider :name="action.icon" />
        <span>{{ action.label }}</span>
      </div>
    </div>
  </details>
</template>

<script>
import IconProvider from '../commons/IconProvider.vue' // Adjust the path as necessary
import actionsData from '../../config/actions.json' // Import the JSON data

export default {
  name: 'AdditionalActionsGrid',
  components: {
    IconProvider,
  },
  data() {
    return {
      isOpen: false,
      actions: [] // Initialize actions as an empty array
    };
  },
  mounted() {
    // Load the actions from the JSON data
    this.actions = actionsData;
  },
  methods: {
    performAction(actionName) {
      alert(`Performing action: ${actionName}`);
      // Replace with your actual action logic
    },
    toggleOpen() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style scoped>

.actions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
  gap: 0.5rem;
  padding: 0.75rem;
}

.action-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 0.75rem;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.2s;
  background-color: #fff;
  gap: 6px;
}

.action-item:hover {
  background-color: #f5f7fa;
}

.action-item .v-icon {
  font-size: 1.5rem;
  margin-bottom: 0.3rem;
  color: #4caf50; /* Adjust icon color */
}

.action-item span {
  font-size: 0.9rem;
}

.action-item-disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none; /* Prevent clicks on disabled items */
}
</style>